var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filter__initial" },
    [
      _c("FiltersLocations", {
        attrs: {
          deleteSubRegions: _vm.deleteSubRegions,
          disableSubRegionDropdown: _vm.disableSubRegionDropdown,
          isTab2: _vm.isTab2,
          locations: _vm.locations,
          selectedRegionID: _vm.selectedRegion,
          selectedSubRegions: _vm.selectedSubRegions,
          subRegionsForRegion: _vm.subRegionsForRegion,
          updateRegion: _vm.updateRegion,
          updateSubRegions: _vm.updateSubRegions,
          name: "regionID",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filters__initial-button-wrapper" },
        [
          _vm.isTab2
            ? _c("div")
            : _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button button-tertiary filters__show-filters",
                    attrs: { "aria-label": "Toggle optional filters" },
                    on: { click: _vm.toggleShowOptions },
                  },
                  [
                    _vm._v("\n        View more filters\n        "),
                    _c("span", { staticClass: "icon icon-filters" }),
                  ]
                ),
              ]),
          _vm._v(" "),
          _c("FiltersApplyButton", {
            attrs: {
              APICall: _vm.APICall,
              applyFiltersText: _vm.applyFiltersText,
              isTab2: _vm.isTab2,
              updateShowOptions: _vm.updateShowOptions,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }